import { WebSocketSubject, webSocket } from 'rxjs/webSocket';

interface ISocketInfo<T> {
  id: any;
  socket: WebSocketSubject<T>;
  lastTrafficTime: number;
}

export class SocketManager<T>  {
  private _sockets: ISocketInfo<T>[] = [];
  private readonly _eventHandler: (data: any) => void;
  private readonly _errorHandler: (error: any) => void;
  private static readonly KEEP_ALIVE_INTERVAL_MS = 1000 * 25;
  private static readonly MAX_TTL_MS = 1000 * 60 * 2;

  constructor(eventHandler: (data: T) => void,
              errorHandler: (error: any) => void) {
    this._eventHandler = eventHandler;
    this._errorHandler = errorHandler;
    this.keepAlive();
  }

  open(id: any, url: string): void {
    this.check(id);

    const ws: WebSocketSubject<T> = webSocket(url);
    this._sockets.push({id: id, socket: ws, lastTrafficTime: Date.now()});
    ws.subscribe(
      (data: any) => {
        this.updateSocket(id);
        this._eventHandler(data);
      },
      (error: any) => {
        this.close(id);
        this._errorHandler(error);
      },
      () => {
        // do nothing?
        // ever hit?
      }
    );
  }

  close(id: any): boolean {
    const index = this._sockets.findIndex(socketInfo => socketInfo.id === id);
    if (index > -1) {
      this._sockets[index].socket.complete();
      this._sockets[index].socket.unsubscribe();
      this._sockets.splice(index, 1);
      return true;
    }

    return false;
  }

  closeAll(): void {
    this._sockets.forEach(socketInfo => {
      socketInfo.socket.complete();
      socketInfo.socket.unsubscribe();
    });
    this._sockets = [];
  }

  private check(id: any): void {
    const existing = this._sockets.find(si => si.id === id);
    if (existing)
      console.warn(`Task ${id} already has a socket open`);
  }

  private keepAlive(): void {
    setInterval(() => {
      this.removeDeadSockets();
      this._sockets.forEach(si => SocketManager.pingServer(si.socket));
    }, SocketManager.KEEP_ALIVE_INTERVAL_MS);
  }

  private updateSocket(id: any): void {
    const socketInfo = this._sockets.find(si => si.id === id);
    if (socketInfo)
      socketInfo.lastTrafficTime = Date.now();
  }

  private removeDeadSockets(): void {
    const copy = [...this._sockets];
    const now = Date.now();
    copy.forEach(si => {
      if (now - si.lastTrafficTime > SocketManager.MAX_TTL_MS) {
        console.log(`Dead socket: ${si.id}`);
        this.close(si.id);
      }
    });
  }

  private static pingServer(ws: WebSocketSubject<any>): void {
    ws.next(true);  // ping server to keep connexn alive (stupid)
  }
}
